/** @jsxImportSource @emotion/react */
import { css, useTheme } from '@emotion/react';
import Button from 'components/common/Button';
import { Mobile } from 'components/common/Responsive';
import pic1 from 'static/main/section5_1.png';
import pic2 from 'static/main/section5_2.png';
import pic3 from 'static/main/section5_3.png';
import pic4 from 'static/main/section5_4.png';
import pic5 from 'static/main/section5_5.png';
import pic6 from 'static/main/section5_6.png';
import pic7 from 'static/main/section5_7.png';
import pic8 from 'static/main/section5_8.png';

const Section4 = () => {
  const { mq } = useTheme();

  const section5Style = css`
    .container {
      max-width: 1535px;
      padding: 344px 40px;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      .text {
        text-align: center;
        .sub {
          font-size: 20px;
          font-weight: 400;
          line-height: 30px;
          color: #6079ff;
        }
        h2 {
          font-size: 56px;
          font-weight: 600;
          line-height: 76px;
          color: #6079ff;
          span {
            color: #58b139;
            font-size: inherit;
            font-weight: inherit;
          }
        }
      }
      img {
        width: 800px;
      }
      button {
        margin-top: 36px;
      }
      .images {
        img {
          position: absolute;
        }
        img:nth-of-type(1) {
          width: 198px;
          top: 89px;
          left: 232px;
        }
        img:nth-of-type(2) {
          width: 245px;
          top: 286px;
          left: 0px;
          z-index: 2;
        }
        img:nth-of-type(3) {
          width: 108px;
          top: 722px;
          left: 150px;
        }
        img:nth-of-type(4) {
          width: 159px;
          top: 614px;
          left: 360px;
        }
        img:nth-of-type(5) {
          width: 224px;
          top: 89px;
          right: 80px;
        }
        img:nth-of-type(6) {
          width: 256px;
          top: 369px;
          right: 0px;
        }
        img:nth-of-type(7) {
          width: 173px;
          top: 579px;
          right: 313px;
        }
        img:nth-of-type(8) {
          width: 101px;
          top: 732px;
          right: 464px;
        }
      }
    }
    ${mq.mobile} {
      .container {
        padding: 300px 40px 403px 40px;
        overflow: hidden;
        .text {
          .sub {
            font-size: 14px;
            font-weight: 400;
            line-height: 22px;
            color: #6079ff;
          }
          h2 {
            font-size: 26px;
            font-weight: 600;
            line-height: 36px;
            color: #6079ff;
            span {
              color: #58b139;
              font-size: inherit;
              font-weight: inherit;
            }
          }
        }
        .images {
          img {
            position: absolute;
          }
          img:nth-of-type(1) {
            width: 88px;
            top: 40px;
            left: 50%;
            margin-left: -60px;
          }
          img:nth-of-type(2) {
            width: 118px;
            top: 80px;
            left: 50%;
            margin-left: -190px;
          }
          img:nth-of-type(3) {
            display: none;
          }
          img:nth-of-type(4) {
            width: 74px;
            top: 120px;
            left: 50%;
            margin-left: 120px;
          }
          img:nth-of-type(5) {
            width: 96px;
            top: 530px;
            left: 50%;
            margin-left: 120px;
          }
          img:nth-of-type(6) {
            width: 110px;
            top: 620px;
            left: 50%;
            margin-left: 35px;
          }
          img:nth-of-type(7) {
            width: 105px;
            top: 602px;
            left: 50%;
            margin-left: -145px;
          }
          img:nth-of-type(8) {
            width: 66px;
            top: 570px;
            left: 50%;
            margin-left: -200px;
          }
        }
      }
    }
  `;
  return (
    <div css={section5Style}>
      <div className="container">
        <div className="text">
          <div className="sub">
            쇼핑몰이 필요한
            <Mobile>
              <br />
            </Mobile>
            인플루언서, 유투버, 개인, 회사, 그리고 셀러까지...
          </div>
          <h2>
            몰파이로 빠르고 쉽게
            <br />
            <span>쇼핑몰을 만들어보세요.</span>
          </h2>
          <Button
            color="blue"
            onClick={() =>
              window.open('https://partner.mallpie.kr/auth/login', '_blank')
            }
          >
            무료로 몰파이 시작하기
          </Button>
        </div>
        <div className="images">
          <img src={pic1} alt="사진1" />
          <img src={pic2} alt="사진2" />
          <img src={pic3} alt="사진3" />
          <img src={pic4} alt="사진4" />
          <img src={pic5} alt="사진5" />
          <img src={pic6} alt="사진6" />
          <img src={pic7} alt="사진7" />
          <img src={pic8} alt="사진8" />
        </div>
      </div>
    </div>
  );
};

export default Section4;
